import Immutable from 'immutable';

import actionTypes from 'src/constants/actionTypes';
import INITIAL_STATE from './initialState';

function handleStateReset(state, { isActive, justSignedOut }) {
  return state.withMutations(map => {
    map.set('accessToken', null);
    map.set('client', null);
    map.set('email', null);
    map.set('emailSentTo', null);
    map.set('errors', null);
    map.set('experiencingServerError', false);
    map.set('expiry', null);
    map.set('id', null);
    map.set('isActive', isActive);
    map.set('isFirstSignIn', false);
    map.set('justSignedOut', justSignedOut);
    map.set('name', null);
    map.set('sentEmailMessage', null);
    map.set('sentEmailSeverity', null);
    map.set('sentEmailStatus', null);
    map.set('uid', null);
  });
}

function authentication(state = INITIAL_STATE, { payload, type }) {
  switch (type) {
    case actionTypes.AUTH__CLEAR_TEMP_STATE:
      return state.withMutations(map => {
        map.set('errors', null);
        map.set('experiencingServerError', false);
        map.set('isActive', false);
        map.set('isFirstSignIn', false);
        map.set('justSignedOut', false);
        map.set('sentEmailMessage', null);
        map.set('sentEmailSeverity', null);
        map.set('sentEmailStatus', null);
      });

    case actionTypes.AUTH__ADD_ERRORS:
    case actionTypes.AUTH__SIGN_IN_FAILURE:
    case actionTypes.AUTH__VERIFY_OTP_FAILURE:
      return state.withMutations(map => {
        map.set('errors', Immutable.fromJS(payload.errors));
        map.set('isActive', false);
      });

    case actionTypes.AUTH__HANDLE_SERVER_ERROR:
      return state.withMutations(map => {
        map.set('experiencingServerError', true);
      });

    case actionTypes.AUTH__CHECK_LAST_EMAIL_STATUS_SUCCESS:
      return state.withMutations(map => {
        const { userInfo : { checkLastEmailStatus } } = payload;

        map.set('sentEmailMessage', checkLastEmailStatus.message);
        map.set('sentEmailSeverity', checkLastEmailStatus.severity);
        map.set('sentEmailStatus', checkLastEmailStatus.status);
      });

    case actionTypes.AUTH__SIGN_IN_START:
      return handleStateReset(
        state,
        {
          isActive      : true,
          justSignedOut : state.get('justSignedOut'),
        },
      );

    case actionTypes.AUTH__SIGN_IN_SUCCESS:
      return state.withMutations(map => {
        map.set('emailSentTo', payload.userInfo.email);
        map.set('errors', null);
        map.set('id', payload.userInfo.id);
        map.set('isActive', false);
        map.set('justSignedOut', false);
      });

    case actionTypes.AUTH__SIGN_OUT:
      return handleStateReset(state, { isActive : false, justSignedOut : true });

    case actionTypes.AUTH__UPDATE_TOKEN:
      return state.withMutations(map => {
        const { userInfo } = payload;

        map.set('accessToken', userInfo.accessToken);
        map.set('expiry', userInfo.expiry);
      });

    case actionTypes.AUTH__UPDATE_USER:
      return state.withMutations(map => {
        const { userInfo } = payload;

        map.set('accessToken', userInfo.accessToken);
        map.set('client', userInfo.client);
        map.set('email', userInfo.email);
        map.set('expiry', userInfo.expiry);
        map.set('uid', userInfo.uid);
      });

    case actionTypes.AUTH__VERIFY_OTP_START:
      return state.withMutations(map => {
        map.set('errors', null);
        map.set('isActive', true);
      });

    case actionTypes.AUTH__VERIFY_OTP_SUCCESS:
      return state.withMutations(map => {
        const { userInfo } = payload;

        map.set('accessToken', userInfo.accessToken);
        map.set('client', userInfo.client);
        map.set('email', userInfo.uid);
        map.set('errors', null);
        map.set('expiry', userInfo.expiry);
        map.set('isFirstSignIn', userInfo.isFirstSignIn);
        map.set('isActive', false);
        map.set('lastAccessTokenFromSignIn', userInfo.accessToken);
        map.set('uid', userInfo.uid);
      });

    default:
      return state;
  }
}

export default authentication;
